// @flow
import { FormControl, FormHelperText, FormLabel, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ErrorMessage, FormikProvider } from "formik";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../../../../locales/pages/namespaces";
import PasswordInput from "../../../mui/form/passwordInput/passwordInput.jsx";
import "./form.css";

const Form = ({ formik, loading }) => {
	const { t } = useTranslation(PAGE_LOGIN);


	const whiteInputStyles = {
		variant: "standard",
		InputProps: {
			disableUnderline: true,
			sx: {
				borderBottom: "1px solid rgba(255,255,255,0.8)",
				pb: 0.5,


				"& .MuiInputBase-input": {
					color: "#fff !important",
				},

				"& .MuiInputBase-input::placeholder": {
					color: "rgba(255,255,255,0.6) !important",
				},

				"& .MuiInputBase-root": {
					color: "#fff !important",
				},
				"& .MuiInputAdornment-root svg": {
					display: "none",
				},
				// "& svg": {
				// 	color: "#fff !important",
				// },

				"&:hover": {
					borderBottom: "1px solid #fff",
				}
			}
		}
	};

	return (
		<FormikProvider value={formik}>
			<Box component="form" onSubmit={formik.handleSubmit} noValidate>
				<Box className={"login-inputs-container"}>

					<FormControl fullWidth sx={{ mb: 3 }}>
						<FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
							{t("Email")}
						</FormLabel>

						<TextField
							{...whiteInputStyles}
							name="email"
							value={formik.values.email}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={t("Enter your email")}
							required
						/>

						<FormHelperText sx={{ color: "#ffd1d1" }}>
							<ErrorMessage name="email" />
						</FormHelperText>
					</FormControl>


					<FormControl fullWidth>
						<FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
							{t("Password")}
						</FormLabel>

						<PasswordInput
							formik={formik}
							name="password"
							label={t("Password")}
							value={formik.values.password}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
									formik.handleSubmit();
								}
							}}
							required
							otherProps={{
								...whiteInputStyles,
								placeholder: t("Password")
							}}
						/>

						<FormHelperText sx={{ color: "#ffd1d1" }}>
							<ErrorMessage name="password" />
						</FormHelperText>
					</FormControl>

					<Button
						fullWidth
						variant="contained"
						type="submit"
						loading={loading}
						sx={{
							mt: 4,
							py: 1.4,
							background: "#FFFFFF",
							color: "#004B88",
							fontWeight: 700,
							borderRadius: "3px",
							textTransform: "none",
							"&:hover": {
								background: "#e6e6e6"
							}
						}}
					>
						{t("Login")}
					</Button>
				</Box>
			</Box>
		</FormikProvider>
	);
};

export default Form;
